<template lang="pug">
  v-card(min-height="80vh")
    v-card-title.pa-0
      v-row.px-5.pt-3(no-gutters align="center" :style="`background-color: ${$vuetify.theme.themes[$theme].infoT08}`")
        v-col.shrink
          v-btn.ml-n3(text icon @click="showModal = !showModal" height)
            eva-icon(name="close-outline" :fill="$vuetify.theme.themes[$theme].basic800" width="24" height="24")
        v-col.ml-3
          p.mb-0.h6.basic800--text Record New Income
      .main-container(style="width:100%")
        v-tabs(v-model="selectedType" fixed-tabs color="textColorAccent" height="40" :background-color="$vuetify.theme.themes[$theme].infoT08")
          v-tab.button-AA-medium by rm
          v-tab.button-AA-medium by product
        div.separator(:style="{ 'background-color':$vuetify.theme.themes[$theme].basic600T16 }")

    v-card-text.px-0.pb-0(id="mainContainer")
    
      .by-amount(v-if="form.type == 'amount'" id="formDataValue")
        .pa-6(:style="{'background-color': $vuetify.theme.themes[$theme].infoT08}")
          v-card(flat)
            v-layout.pa-4(@click="openCalculatorInputDialog = true")
              div.mr-4.my-auto(style="height:24px")
                CashIcon(size="24" :style="{ 'color': $vuetify.theme.themes[$theme].primary500 }")
              .h6.primary500--text {{ form.data.value | displayPrice }}
      
      .by-item(v-if="form.type == 'item'" id="formDataProducts")
        .pa-6(:style="{'background-color': $vuetify.theme.themes[$theme].infoT08}")
          v-card(flat)
            v-layout.pa-4(@click="openAddProductsDialog = true")
              div.my-auto.mr-4(style="height:24px")
                eva-icon(name="shopping-bag-outline" :fill="$vuetify.theme.themes[$theme].primary500" width="24")
              .h6.primary500--text
                span(v-if="form.data.products.length > 0") Add/Edit item
                span(v-else) Add item
              v-spacer
              div.my-auto.mr-4(style="height:24px")
                eva-icon(name="plus-outline" :fill="$vuetify.theme.themes[$theme].info500" width="24")
        v-list.pa-0
          template(v-for="(item, index) in form.data.products")
            v-list-item.px-6(:key="item.product.id" :style="{'background-color': index % 2 === 0? $vuetify.theme.themes[$theme].basic200 : $vuetify.theme.themes[$theme].basic100}" @click="openAddProductsDialog = true")
              v-list-item-icon
                v-chip(:color="$vuetify.theme.themes[$theme].infoT08" small style="border: 1px solid var(--v-info);")
                  .p2.info500--text x {{ item.quantity }}
              v-list-item-content
                v-list-item-title.s2 {{ item.product.name }}
                template(v-if="item.addons && addon.quantity_per_set" v-for="addon in item.addons")
                  .mb-0.caption.grey--text.text--darken-1(style="font-size: 12px !important") - {{ addon.name || item.product.name }}
              v-list-item-icon
                v-col.pa-0.text-right
                  .p2 {{ productPrice(item) | displayPrice }}
                  .p2.primary400--text(v-if="productDiscount(item)") - {{ productDiscount(item) | displayPrice }}
            v-divider.basic300

      v-form.py-6(ref="form")
        .px-6
          .label.basic600--text.text-uppercase(id="formDataDate") Date
          v-dialog(v-model='form.data.date.show' width='290px')
            template(v-slot:activator='{ on }')
              v-text-field.mt-2(:value="form.data.date.value" placeholder="Select date" outlined dense background-color="basic200" readonly v-on='on' :rules="rules.is_selected")
                template(v-slot:append)
                  eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
            v-date-picker(v-model='form.data.record_date' color="primary" no-title @change="saveDate()")
            
          .label.basic600--text.text-uppercase(id="formDataCategory") Category (required)
          v-select.mt-2(v-model="form.data.category" item-text="name" item-value="id" :items="categories" outlined dense background-color="basic200" placeholder="Select income category" :rules="rules.is_selected" return-object :loading="isFetchingCategories" append-icon="")

            template(v-slot:item="{ index, item, attrs }")
              v-layout
                v-list-item-content
                  v-list-item-title.s1(:class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.name }}
                  v-list-item-subtitle.c1(v-if="item.description" :class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.description }}
          
          .label.basic600--text.text-uppercase Description
          v-text-field.mt-2(v-model='form.data.description' background-color="basic200" height="40" outlined dense placeholder="Write a description for this income")

        v-divider.basic300.my-4
        .px-6
          .label.basic600--text.text-uppercase Customer
          v-text-field.mt-2(:value="form.data.customer.name" placeholder="Add customer" outlined dense background-color="basic200" readonly hide-details @click="openAddCustomersDialog = true")
            template(v-slot:append)
              eva-icon(name="plus-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700" @click="openAddCustomersDialog = true")
          .guide.mt-3.d-flex
            eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15")
            div.c1.basic600--text Fill this field to
              span.c2.basic600--text  generate receipts, invoices or quotations
          
          .notes.mt-4
            .label.basic600--text.text-uppercase Notes
            v-text-field.mt-2(v-model='form.data.notes' placeholder="Write notes here" background-color="basic200" hide-details outlined dense :maxlength="200")
            .guide.mt-3.d-flex
              eva-icon.mr-2(name="info-outline" :fill="$vuetify.theme.themes[$theme].basic600" height="15" width="15")
              div.c1.basic600--text Your customers will see this in their invoices
          
          .discount.mt-4
            v-layout(v-if="invoiceDiscount")
              .s2.primary400--text(v-if="invoiceDiscount.isPercentage") Discount: {{ invoiceDiscount.value }}%
              .s2.primary400--text(v-else) Discount: {{ invoiceDiscount.value | displayPrice }}
              eva-icon.mt-1.ml-2(name="trash-outline" height="16" width="16" :fill="$vuetify.theme.themes[$theme].danger500" @click="invoiceDiscount = null")
            v-btn.button-Aa-medium.custom-transform-class.text-none.px-2.ml-n3(v-else color="textColorAccent" text @click="openEditDiscount = true" small)
              eva-icon.mt-1.mr-2(name="plus-outline" :fill="$vuetify.theme.themes[$theme].textColorAccent" height="20" width="20")
              | Add discount

        v-divider.basic300.my-4
        .px-6
          .payment-status.pt-2
            .label.basic600--text.text-uppercase Payment Status
            v-row.px-3.mb-4
              v-radio-group.mt-2(v-model='form.paymentStatus' row dense)
                v-radio.mb-4(value='paid' style="width:100%")
                  template(v-slot:label)
                    div
                      .p1.textColorDefault--text Paid
                v-radio.mb-4(value='unpaid' style="width:100%")
                  template(v-slot:label)
                    div
                      .p1.textColorDefault--text Unpaid
                v-radio.mb-4(value='partial' style="width:100%")
                  template(v-slot:label)
                    div
                      .p1.textColorDefault--text Partial Paid / Deposit
                v-radio(value='quotation' style="width:100%")
                  template(v-slot:label)
                    div
                      .p1.textColorDefault--text Make this a quotation
        v-divider.basic300.my-4
        .px-6
          .payment-method(v-if="form.paymentStatus == 'partial'" id="formPaymentAmount")
            .label.basic600--text.text-uppercase Amount paid
            v-text-field.mt-2(v-model='form.paymentAmount' placeholder="0" dense outlined height="40" background-color="basic200" type="number" :prefix="$currency.symbol"  :rules="priceRules")

          .payment-method(v-if="form.paymentStatus == 'paid' || form.paymentStatus == 'partial'" id="formPaymentMethod")
            .label.basic600--text.text-uppercase Payment Method
            v-row.px-3.mb-n2.mt-2
              v-radio-group.mt-2(v-model='form.paymentMethod' row dense)
                v-radio.mb-4(v-for="(method, index) in paymentMethods" :value="method.name" style="width:100%" :key="method.id")
                  template(v-slot:label)
                    div
                      .p1.textColorDefault--text {{ method.name }}

          .payment-due-date.pb-6(v-if="form.paymentStatus != 'paid'" id="formPaymentDueDate")
            .label.basic600--text.text-uppercase Payment due
            v-dialog(v-model='form.date.show' width='290px')
              v-date-picker(v-model='form.paymentDueDate' color="primary" no-title @change="saveDueDate()")
            v-select.mt-2(v-model="form.paymentDueDate" background-color="basic200" outlined dense hide-no-data hide-details :items="dueDateChoices" item-text="name" item-value="id")
              template(v-slot:append)
                eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")

    v-card-actions
      v-col.pa-0
        v-layout.px-4.pt-2
          .s1.textColorDefault--text Total amount:
          .s1.info400--text.ml-2 {{ totalAfterDiscount | displayPrice }}
        v-layout
          v-spacer
          v-btn(color='white', text @click='showModal = false')
            .button-Aa-medium.primary400--text Cancel
          v-btn.mr-2(color='info500' depressed @click="clickProceed()" :loading="loading")
            .button-AA-medium.basic100--text {{ $t('save') }}

    .modals
      CalculatorInput(v-if="openCalculatorInputDialog" :open.sync="openCalculatorInputDialog" :initial="form.data.value" @input="handleInput")
      AddProducts(:open.sync="openAddProductsDialog" :initial.sync="form.data.products" @confirm="updateProducts")
      AddCustomers(:open.sync="openAddCustomersDialog" @confirm="updateCustomer")
      AddDiscount(v-if="openEditDiscount" :open.sync="openEditDiscount" :initialDiscount.sync="invoiceDiscount" @added="handleAddDiscount")
      

</template>

<script>
import { DateTime } from 'luxon'
import { mapActions, mapGetters } from 'vuex'
import CalculatorInput from '@/components/yezzabook/dialogs/CalculatorInput.vue'
import AddProducts from '@/components/yezzabook/dialogs/income/addincome/AddProducts.vue'
import AddCustomers from '@/components/yezzabook/dialogs/income/addincome/AddCustomers.vue'
import AddDiscount from '@/components/yezzabook/dialogs/income/addincome/AddDiscount.vue'

export default {
  name: 'RecordIncome',
  props: ['open', 'step', 'loading'],
  components: { CalculatorInput, AddProducts, AddCustomers, AddDiscount },
  data: () => ({
    isLoading: false,
    openCalculatorInputDialog: false,
    openAddProductsDialog: false,
    openAddCustomersDialog: false,
    openEditDiscount: false,
    selectedType: 0,
    disableQuotation: true,
    isFetchingCategories: true,
    invoiceDiscount: null,
    form: { 
      // income
      type: 'amount',
      data: { 
        value: 0,
        products: [],
        category: null,
        record_date: null,
        description: null,
        notes: null,
        date: {
          show: false,
          value: null
        },
        customer: {
          name: "Guest"
        },
        quotation: false
      },
      // payment
      paymentStatus: 'paid',
      paymentMethod: null,
      paymentDueDate: null,
      paymentAmount: null,
      date: {
        show: false,
        value: null
      }
    },
    categories: [],
    paymentMethods: [],
    dueDateChoices: [],
    originalDateChoices: [],
    options: {
      duration: 200,
      offset: 0,
      easing: 'linear',
      container: '#mainContainer'
    },
    rules: {
      is_selected: [(v) => v !== null || 'This field is required'],
      has_quantity: [(v) => !!v || 'This field is required', (v) => v > 0|| 'This field is required']
    }
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showModal: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    },
    totalInvoiceDiscount () {
      if (!this.invoiceDiscount) {
        return 0
      }
      let discountAmount = this.invoiceDiscount.value
      if (this.invoiceDiscount.isPercentage) {
        discountAmount = this.invoiceDiscount.value * (this.form.type == 'amount' ? this.form.data.value : this.totalPrice) / this.$currency.multiplier
      }
      return parseInt(discountAmount)
    },
    totalPrice() {
      let total = 0
      this.form.data.products.forEach(o => {
        let discount = o.discount
        if (o.show_discount_as_percentage) {
          discount = o.discount * o.product.price / this.$currency.multiplier
        }
        let addonprice = 0
        if (o.addons) {
          o.addons.forEach(a => {
            addonprice += (a.price * a.quantity_per_set)
          })
        }
        total += (o.quantity * ((o.product.price - discount) + addonprice))
      })
      return total
    },
    totalAfterDiscount () {
      return (this.form.type == 'amount' ? this.form.data.value : this.totalPrice) - this.totalInvoiceDiscount
    },
    priceRules () {
      return [
        v => !!v || 'Amount is required',
        v => v != 0|| 'Amount is required',
        v => v <= this.totalAfterDiscount/this.$currency.multiplier || `Amount should not be above ${this.$currency.symbol} ${(parseFloat(this.totalAfterDiscount/this.$currency.multiplier)).toFixed(this.$currency.exponent)}`,
      ]
    }
  },
  watch: {
    selectedType (val) {
      if (val === 1) {
        this.form.type = 'item'
      } else {
        this.form.type = 'amount'
      }
      this.$store.commit('ui/setLastIncomeTabPosition', val)
    },
    'form.data.record_date' () {
      this.form.paymentDueDate = this.form.data.record_date
      const selectedDate = DateTime.fromFormat(this.form.data.record_date, 'yyyy-MM-dd')
      this.originalDateChoices = [
        { name: `Due ${selectedDate.toFormat('dd/MM/yyyy')}`, id: selectedDate.toFormat('yyyy-MM-dd') },
        { name: 'Within 15 days', id: selectedDate.plus({ days: 15 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 30 days', id: selectedDate.plus({ days: 30 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 45 days', id: selectedDate.plus({ days: 45 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 60 days', id: selectedDate.plus({ days: 60 }).toFormat('yyyy-MM-dd') },
        { name: 'Within 90 days', id: selectedDate.plus({ days: 90 }).toFormat('yyyy-MM-dd') },
        { name: 'Custom', id: 'custom'}
      ]
      this.dueDateChoices = [ ...this.originalDateChoices ]
    },
    'form.paymentDueDate' (val) {
      if (val === 'custom') {
        this.form.date.show = true
        this.form.paymentDueDate = this.form.data.record_date
      }
      if (val) {
        this.dueDateChoices = [ ...this.originalDateChoices ]
        this.dueDateChoices.push({ name: this.formatDate(this.form.paymentDueDate), id: this.form.paymentDueDate})
      } else {
        this.dueDateChoices = [ ...this.originalDateChoices ]
      }
    }
  },
  mounted () {
    this.selectedType = this.$store.state.ui.lastIncomeTabPosition
    this.form.data.record_date = DateTime.local().toFormat('yyyy-MM-dd')
    this.form.data.date.value = this.formatDate(this.form.data.record_date)
    this.fetchCategories()
    this.getPaymentMethods()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchCategories () {
      this.$axios.get(`/books/${this.company.slug}/income_categories`)
        .then((response) => {
          this.isFetchingCategories = false
          this.form.data.category = response.data.results.filter(category => category.name.toLowerCase() === 'sales')[0]
          this.categories = [this.form.data.category]
        }).catch(() => {})
    },
    handleInput (val) {
      this.form.data.value = (parseFloat(val)).toFixed(this.$currency.exponent).replace('.', '')
    },
    updateProducts (val) {
      this.form.data.products = [ ...val ]
    },
    updateCustomer (val) {
      this.form.data.customer = val
    },
    saveDate () {
      this.form.data.date.show = false
      this.form.data.date.value = this.formatDate(this.form.data.record_date)
    },
    saveDueDate () {
      this.form.date.show = false
      this.form.date.value = this.formatDate(this.form.paymentDueDate)
    },
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    clickProceed () {
      let finalData = {}
      // generate income object
      let data = {}
      if (this.form.type === 'amount') {
        if (!this.form.data.value || this.form.data.value === '000') {
          this.showMessage(['error', this.$t('error_message.amount_is_required')])
          this.$vuetify.goTo('#formDataValue', this.options)
          return
        }
        data.amount = this.form.data.value
      } else if (this.form.type === 'item') {
        if (this.form.data.products.length <= 0) {
          this.showMessage(['error', this.$t('error_message.item_is_required')])
          this.$vuetify.goTo('#formDataProducts', this.options)
          return
        }
        data.products = this.finalProducts()
      }
      this.$refs.form.validate()
      if (!this.form.data.category) {
        this.showMessage(['error', this.$t('error_message.category_is_required')])
        this.$vuetify.goTo('#formDataCategory', this.options)
        return
      }
      data.categoryObject = this.form.data.category
      data.category = this.form.data.category.id
      if (!this.form.data.record_date) {
        this.showMessage(['error', this.$t('error_message.date_is_required')])
        this.$vuetify.goTo('#formDataDate', this.options)
        return
      }
      data.record_date = this.form.data.record_date
      if (this.form.data.description) {
        data.description = this.form.data.description
      }
      if (this.form.data.notes) {
        data.notes = this.form.data.notes
      }
      if (this.form.data.customer.name) {
        data.name = this.form.data.customer.name
        if (this.form.data.customer.email) {
          data.email = this.form.data.customer.email
        }
        if (this.form.data.customer.phone) {
          data.phone = this.form.data.customer.phone
        }
        if (this.form.data.customer.address) {
          data.address = this.form.data.customer.address
        }
      } else {
        data.name = 'Guest'
      }
      data.quotation = this.form.paymentStatus === 'quotation'
      if (this.form.paymentDueDate && this.form.paymentStatus !== 'paid') {
        if (data.quotation) {
          data.quotation_due_date = this.form.paymentDueDate
        } else {
          data.due_date = this.form.paymentDueDate
        }
      }
      finalData.income = { ...data }
      data = {}

      // generate payment object
      if (!this.form.paymentMethod && (this.form.paymentStatus == 'paid' || this.form.paymentStatus == 'partial')) {
        this.showMessage(['error', this.$t('error_message.payment_method_required')])
        this.$vuetify.goTo('#formPaymentMethod', this.options)
        return
      }
      if (this.form.paymentMethod && (this.form.paymentStatus == 'paid' || this.form.paymentStatus == 'partial')) {
        data.payment_method = this.form.paymentMethod
        data.date = this.form.data.record_date
      }
      if (this.form.paymentStatus == 'partial' && this.form.paymentAmount) {
        data.amount = (parseFloat(this.form.paymentAmount)).toFixed(this.$currency.exponent).replace('.', '')
      }
      finalData.payment = { ...data }
      data = {}
      
      // generate invoice object
      if (this.totalInvoiceDiscount) {
        data.invoice_discount = this.totalInvoiceDiscount
      }
      finalData.invoice = { ...data }
      this.$emit('add', finalData)
    },
    handleAddDiscount (val) {
      this.invoiceDiscount = val
    },
    productDiscount (prod) {
      let discount = prod.discount
      if (prod.show_discount_as_percentage) {
        discount = prod.discount * prod.product.price / this.$currency.multiplier
      }
      return prod.quantity * parseInt(discount)
    },
    productPrice (prod) {
      let addonprice = 0
      if (prod.addons) {
        prod.addons.forEach(a => {
          addonprice += (a.price * a.quantity_per_set)
        })
      }
      return (prod.quantity * (prod.product.price + addonprice))
    },
    finalProducts () {
      const products = []
      this.form.data.products.forEach(item => {
        let discount = item.discount
        if (item.show_discount_as_percentage) {
          discount = item.discount * item.product.price / this.$currency.multiplier
        }
        const selectedItem = {
          id: item.id || null,
          product: item.product.id,
          quantity: item.quantity,
          discount: discount || 0,
          show_discount_as_percentage: item.show_discount_as_percentage || false,
        }
        if (item.addons) {
          selectedItem.addons = [...item.addons.map(m => { return {
            id: m.edit_id || null,
            product: m.id,
            quantity_per_set: m.quantity_per_set
          }}).filter(f => (!item.id && f.quantity_per_set > 0) || item.id)]
        }
        products.push(selectedItem)
      })
      return products
    },
    getPaymentMethods () {
      this.isLoading = true
      this.$axios.get(`/books/${this.company.slug}/payment_methods`).then((response) => {
        this.isLoading = false
        this.paymentMethods = [...response.data.results]
        this.form.paymentMethod = response.data.results.filter(method => method.name.toLowerCase() === 'bank transfer')[0]
        if (!this.form.paymentMethod) {
          this.form.paymentMethod = this.paymentMethods[0].name
        } else {
          this.form.paymentMethod = this.form.paymentMethod.name
        }  
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.main-container {
  position: relative;
}
.separator {
  position: absolute;
  height:2px;
  top: 38px;
  left: 0px;
  right: 0px;
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
</style>

<i18n>
{
  "en": {
    "cancel": "Cancel",
    "save": "Save"
  }
}
</i18n>
